module.exports = __webpack_public_path__ + "static/media/SOLUTION 2020.b35eafb4.pdf";